import React, {useCallback, useEffect, useState} from 'react';

import {
  Container,
  Content,
  LocationColumn,
  LocationContainer,
  TitlesContainer,
  LocationIcon,
  LocationInfos,
  LocationText,
  Title,
} from './styles';
import {ShoppingItem} from '../../components/shared/Shopping/ShoppingItem';
import {version} from '../../../package.json';

import {useFocusEffect, useNavigation, useRoute} from '@react-navigation/native';
import {rastrear, STATUS_BY_TIPO_PRODUTO} from '../../services/rastrear';
import {api} from '../../services/api';

import analytics from '@react-native-firebase/analytics';
import {Loading} from '../../components/Interface/Loadings/Loading';

import {ProductDTO} from '../../dtos/ProductDTO';
import {RFValue} from 'react-native-responsive-fontsize';
import {Header} from '../../components/Interface/Headers/Header';

import {Badge} from '../../components/Interface/Badges/Badge';
import {useTheme} from 'styled-components/native';
import {RootStackParamList} from '../../dtos/RoutesDTO';
import {SearchInput} from '../../components/Interface/Forms/Inputs/SearchInput';
import {getPersistentDeviceId} from '../../utils/deviceId';
import {getInstallAttributionData} from '../../utils/installAttribution';
import { Platform } from 'react-native';
import {addInAppTrigger} from '../../lib/pushMessaging';

export function Products() {
  const route = useRoute();
  const theme = useTheme();
  const navigation = useNavigation();


  const {
    localidade,
    tipo,
    cidade,
    estado,
    categoria,
    posto,
    coupon,
    products: routeProducts,
  } = route.params as RootStackParamList['Products'];

  const [data, setData] = useState<ProductDTO[]>([]);

  const [isLoading, setIsLoading] = useState(false);

  function handleFuelDetails() {
    analytics().logEvent('seleciona_combustivel', {
      item_list_name: tipo,
    });

    navigation.navigate('Fuel', {
      localidade: {
        cidade,
        estado,
        rank: categoria,
        region: localidade,
        tipo,
      },
      posto,
      fuels: data,
      coupon,
    });
  }

  function handleProductDetails(
    id: string,
    name: string,
    price: string,
    alerta: string,
    imageUrl: string,
    unidade: string,
    volume: {volume: number}[],

  ) {
    analytics().logEvent('seleciona_produto', {
      item_list_name: tipo,
    });

    navigation.navigate('Product', {
      id,
      name,
      price,
      alerta,
      imageUrl,
      unidade,
      volume,
      localidade: {
        cidade,
        estado,
        rank: categoria,
        region: localidade,
        tipo,
      },
      posto,
    });
  }

  useEffect(() => {
    let isMounted = true;

    async function fetchProducts() {
      setIsLoading(true);

      if (tipo === 'C') {
        analytics().logEvent('lista_combustiveis');
        if(Platform.OS !== 'web'){
 addInAppTrigger('screen', 'fuel_shopping');
        }

      }

      if (tipo === 'P') {
        analytics().logEvent('lista_racao');
         if(Platform.OS !== 'web'){
        addInAppTrigger('screen', 'racao_shopping');
         }
      }

      if (tipo === 'G') {
        analytics().logEvent('lista_gas');
         if(Platform.OS !== 'web'){
        addInAppTrigger('screen', 'gas_shopping');
         }
      }

      if (tipo === 'O') {
        analytics().logEvent('lista_oleo');
         if(Platform.OS !== 'web'){
        addInAppTrigger('screen', 'oleo_pneu_shopping');
         }
      }

      const deviceId = await getPersistentDeviceId();

      const instalacao = await getInstallAttributionData();

      try {
        await api
          .get('/fuels', {
            params: {
              tipo,
              versao: version,
              regiao: localidade,
              deviceId,
              codigo_desconto: coupon?.codigo,
              instalacao,
            },
          })
          .then(({data}) => {

            setData(data);
            setIsLoading(false);
          })
          .catch(() => {
            if (isMounted) {
              setIsLoading(false);
            }
          });
      } catch (error) {
        console.log(error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
          isMounted = false;
        }
      }
    }

    if (!routeProducts?.length) {
      fetchProducts();
    } else {
      setData(routeProducts);
    }

    return () => {
      isMounted = false;
    };
  }, []);

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredProducts, setFilteredProducts] = useState(data);

  useFocusEffect(
    useCallback(() => {
      const status_tela = STATUS_BY_TIPO_PRODUTO[tipo];
      if (status_tela) {
        rastrear({status_tela, cidade});
      }
    }, [tipo, cidade]),
  );

  const handleSearchStations = (text: string) => {
    const normalize = (str: string) =>
      str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

    const normalizedText = normalize(text);

    const filtered = data.filter((product: ProductDTO) =>
      normalize(product.name).includes(normalizedText),
    );

    setFilteredProducts(text ? filtered : data);
    setSearchTerm(text);
  };

  useEffect(() => {
    setFilteredProducts(data);
  }, [data]);

  return (
    <Container>
      {isLoading && <Loading />}
      <Header
        icon="chevron-left"
        rightIcon="x"
        rightIconAction={() => navigation.navigate('Shopping')}
      />
      <LocationContainer>
        <LocationColumn>
          <LocationIcon name="map-pin" />
          <LocationInfos>
            <LocationText>
              {cidade}, {estado}
            </LocationText>
            {categoria === 'ouro' && (
              <Badge
                text="Super Barato"
                containerStyle={{
                  backgroundColor: theme.colors.gold,
                  borderColor: theme.colors.gold_dark,
                }}
                textStyle={{
                  color: theme.colors.gold_text,
                }}
              />
            )}
            {categoria === 'prata' && (
              <Badge
                text="Barato"
                containerStyle={{
                  backgroundColor: theme.colors.silver,
                  borderColor: theme.colors.silver_dark,
                }}
                textStyle={{
                  color: theme.colors.silver_text,
                }}
              />
            )}
          </LocationInfos>
        </LocationColumn>
      </LocationContainer>

      <TitlesContainer>
        <SearchInput
          placeholder="Buscar produtos..."
          value={searchTerm}
          onChangeText={handleSearchStations}
        />
        <Title>Produtos</Title>
      </TitlesContainer>

      <Content
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          paddingBottom: RFValue(20),
        }}>
        {tipo === 'C' &&
          data.length > 0 &&
          filteredProducts.map((fuel: ProductDTO) => {
            return (
              <ShoppingItem
                key={fuel.id}
                data={fuel}
                activeOpacity={1}
                productType="C"
                onPress={() => handleFuelDetails()}
              />
            );
          })}

        {tipo !== 'C' &&
          data.length > 0 &&
          filteredProducts.map((product: ProductDTO) => (
            <ShoppingItem
              key={product.id}
              data={product}
              activeOpacity={1}
              productType={tipo}
              onPress={() =>
                handleProductDetails(
                  product.id,
                  product.name.charAt(0).toUpperCase() + product.name.slice(1),
                  product.valorComDesconto,
                  product.alerta,
                  product.imageUrl,
                  product.unidade,
                  product.volume,
                )
              }
            />
          ))}
      </Content>
    </Container>
  );
}
